import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CardActions,
  Button,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { useMutation } from "@tanstack/react-query";
import HttpService from "../../services/HttpService";

const documents = [
  {
    id: 1,
    document: "Online.Brochure",
    title: "Online Brochure",
    description: "Download the online brochure.",
  },
  {
    id: 2,
    document: "Trifold",
    title: "Trifold",
    description: "Download the trifold.",
  }
];

export default function MarketingMaterials(props) {
  const downloadMutation = useMutation(
    ({idEmployer, document}) => {
      return HttpService.getAxiosClient().get(
        window.API_URL + `/employer/${idEmployer}/marketing-materials/${document}`,
        {
          responseType: "blob",
        }
      );
    },
    {
      onSuccess: (response) => {
        const { headers, data } = response;
        const disposition = headers["content-disposition"];
        let filename = disposition.split(/;(.+)/)[1].split(/=(.+)/)[1];
        if (filename.toLowerCase().startsWith("utf-8''"))
          filename = decodeURIComponent(filename.replace("utf-8''", ""));
        else filename = filename.replace(/['"]/g, "");
        let url = window.URL.createObjectURL(data);
        let a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a); // append the element to the dom
        a.click();
        a.remove(); // afterwards, remove the element
      },
      onError: (error) => {
        alert("Download failed. Please try again.");
      },
    }
  );

  if (!props.employer) {
    return (
      <Typography variant="h6" color="error" sx={{ p: 3 }}>
        No employer selected.
      </Typography>
    );
  }

  return (
    <div style={{
      cursor: downloadMutation.isLoading ? "progress" : "default"
    }}>
      <div>
        <Typography variant="h4" gutterBottom>
          Marketing Materials for employer: {props.employer.name}
        </Typography>
        <Typography variant="body1" gutterBottom>
          Download the latest marketing materials for your program.
        </Typography>
      </div>
      <Grid container spacing={3} sx={{ padding: 3 }}>
        {documents.map((doc) => {
            return (
          <Grid item xs={12} sm={6} md={6} key={doc.id}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {doc.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {doc.description}
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  size="small"
                  variant="contained"
                  disabled={downloadMutation.isLoading}
                  color="primary"
                  onClick={() =>
                    downloadMutation.mutate(
                        {
                            idEmployer: props.employer.idEmployer,
                            document: doc.document+".EN",
                        }
                    )
                  }
                  target="_blank"
                  startIcon={<DownloadIcon />}
                  download
                >
                  English
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  disabled={downloadMutation.isLoading}
                  color="primary"
                  onClick={() =>
                    downloadMutation.mutate(
                        {
                            idEmployer: props.employer.idEmployer,
                            document: doc.document+".ES",
                        }
                    )
                  }
                  target="_blank"
                  startIcon={<DownloadIcon />}
                  download
                >
                  Spanish
                </Button>
              </CardActions>
            </Card>
          </Grid>
        )} )}
        
      </Grid>
    </div>
  );
}
